const MenuBtnExpanded = props => {
    const { menu, onClick } = props

    return <div
        className="expanded"
        onClick={onClick}
    >
        <div className="wrapper">
            {menu.map(i => <div className="item" data-url={i.key} key={i.key}>
                {i.label}
            </div>)}
        </div>
    </div>
}

export default MenuBtnExpanded
